<template>

  <svg viewBox="0 0 24 24" role="presentation" focusable="false" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M21.399 5.913l-.437-.252a2.21 2.21 0 000-.822l.437-.252a.75.75 0 00-.75-1.3l-.438.254c-.21-.18-.45-.32-.71-.412v-.504a.75.75 0 10-1.5 0v.504c-.261.093-.502.232-.712.412l-.437-.253a.75.75 0 00-.75 1.3l.437.251a2.21 2.21 0 000 .822l-.437.252a.75.75 0 10.75 1.3l.438-.254c.209.18.45.32.71.412v.504a.75.75 0 001.5 0v-.504c.26-.093.501-.232.71-.412l.439.253a.75.75 0 10.75-1.3zM18 5.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm2.752 4.51a.75.75 0 00-.616.864c.076.454.114.915.114 1.376a8.214 8.214 0 01-2.085 5.476 7.468 7.468 0 00-3.38-2.695 4.5 4.5 0 10-5.57 0 7.468 7.468 0 00-3.38 2.695 8.25 8.25 0 017.541-13.612.75.75 0 00.248-1.479 9.743 9.743 0 107.991 7.991.75.75 0 00-.863-.616zM9 11.25a3 3 0 116 0 3 3 0 01-6 0zm-2.055 7.266a6 6 0 0110.11 0 8.234 8.234 0 01-10.11 0z"/></svg>

</template>


<script>

  export default {"name":"icon-5d6e5c99224ac15c92a81b9d03cf529c"}

</script>